import { StoreOfferProduct, isGemPackOffer } from '@common'
import { useTranslations } from 'next-intl'

import { useIsLoggedIn } from '../../common/useIsLoggedIn'
import { BonusContainer } from '../_storeBase/bonus/BonusContainer'
import { Bundles } from '../_storeBase/bundles/Bundles'
import Offers from '../_storeBase/offers/Offers'
import { ProductCategory } from '../_storeBase/productCategory/ProductCategory'
import { GameContainer } from '../_storeBase/structure/GameContainer'
import { StoreContent } from '../_storeBase/structure/StoreContent'
import { Subsection } from '../_storeBase/structure/Subsection'
import { isStoreSpecial, sortByPriority, isNormalOffer, isSeasonPass } from '../productFilters'
import { StoreFrontProps } from '../types'
import Passes from './Passes/Passes'

const ClashRoyaleStoreFront = ({ products, bonusStatus }: StoreFrontProps) => {
  const loggedIn = useIsLoggedIn()
  const t = useTranslations()

  const specials = products.filter(isStoreSpecial).sort(sortByPriority) as StoreOfferProduct[]
  const normalOffers = products
    .filter((product) => isNormalOffer(product) && !isGemPackOffer(product))
    .sort(sortByPriority) as StoreOfferProduct[]
  const passes = products.filter(isSeasonPass) as StoreOfferProduct[]
  const gems = products.filter(isGemPackOffer).sort(sortByPriority)

  return (
    <GameContainer>
      <StoreContent>
        <Bundles bundles={specials} />
        <Passes products={passes} />
        <Offers products={normalOffers} />

        <Subsection fullWidth>
          <ProductCategory title={t('game_cat_gems')} products={gems} productType="GEM" />
        </Subsection>
      </StoreContent>
      {loggedIn && bonusStatus && <BonusContainer bonusStatus={bonusStatus} />}
    </GameContainer>
  )
}

export default ClashRoyaleStoreFront
